import { cloneDeep } from 'lodash';

export const mapEveryBigintIntoNumber = (value: { [key: string]: unknown }): { [key: string]: unknown } => {
    const _value = cloneDeep(value);

    for (const key of Object.keys(value)) {
        switch (typeof _value[key]) {
            case 'bigint':
                _value[key] = Number(_value[key]);
                break;
            case 'object':
                switch (true) {
                    case _value[key] !== null:
                        _value[key] = mapEveryBigintIntoNumber(_value[key] as { [key: string]: unknown });
                        break;
                    case Array.isArray(_value[key]) && (_value[key] as bigint[]).length > 0:
                        switch (typeof (_value[key] as unknown[])[0]) {
                            case 'bigint':
                                _value[key] = (_value[key] as bigint[]).map(Number);
                                break;
                            case 'object':
                                _value[key] = (_value[key] as { [key: string]: unknown }[]).map(
                                    mapEveryBigintIntoNumber
                                );
                                break;
                        }
                        break;
                }
        }
    }

    return _value;
};
